import {ComponentType, FC, PropsWithChildren} from "react";
import {CustomElementStatus} from "./CustomElementStatus";
import {useCustomElementStatus} from "./useCustomElementStatus";
import {PlaceholderProps} from "./PlaceholderProps";
import {DefaultPlaceholder} from "./DefaultPlaceholder";

export interface CustomElementProps {
  element: string | string[];
  placeholder?: ComponentType<PlaceholderProps>;
}

export const WhenDefined: FC<PropsWithChildren<CustomElementProps>> = ({
  element,
  placeholder = DefaultPlaceholder,
  children
}) => {
  const Placeholder = placeholder;
  const status = useCustomElementStatus(element);
  switch (status) {
    case CustomElementStatus.DEFINED:
      return <>{children}</>;
    case CustomElementStatus.UNDEFINED:
      return <Placeholder element={element} />;
  }
};
